/**
 * Slim homepage (restructured 2026-07-26).
 *
 * Landing visitors should understand what Zynthoro is in 10 seconds and
 * know exactly where to click for depth. Long-form sections live at:
 *   /modules     — the 12 ERP modules
 *   /assistants  — the four AI specialists in detail
 *   /pricing     — full tier comparison, Enterprise, competitor comparison
 *   /blog        — Latest Articles
 */
import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import HomeIntro from "@/components/sections/HomeIntro";
import WorkflowSection from "@/components/sections/WorkflowSection";
import CostReplacement from "@/components/sections/CostReplacement";
import VoiceInputCallout from "@/components/sections/VoiceInputCallout";
import FoundingMembers from "@/components/sections/FoundingMembers";
import PricingFeaturedThree from "@/components/sections/PricingFeaturedThree";
import LatestArticles from "@/components/sections/LatestArticles";
import { PresaleDialogProvider } from "@/components/sections/PresaleDialog";

export default function Home() {
  useEffect(() => {
    document.title =
      "Zynthoro — CRM, Projects, Finance & AI in One Business Platform";

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta(
      "description",
      "Zynthoro AI business platform for SMEs · Kickstart lifetime access from €79 · Starter subscription €499/month. Explore plans and features."
    );

    // Reveal on scroll
    const els = document.querySelectorAll(".zy-reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <PresaleDialogProvider>
      <Navbar />
      <main data-testid="page-home">
        <Hero />
        <HomeIntro />
        <WorkflowSection />
        <CostReplacement />
        <VoiceInputCallout />
        <PricingFeaturedThree />
        <FoundingMembers />
        <LatestArticles />
      </main>
      <Footer />
    </PresaleDialogProvider>
  );
}
